module.exports = __webpack_public_path__ + "static/media/clothes.d0e36b67.gltf";